export default __webpack_public_path__ + "281f25449166f7c0eb8629385b4e4b6b.png";